import { render } from "./Labels.vue?vue&type=template&id=2a0a1c27&bindings={\"group\":\"props\",\"fetchData\":\"options\",\"create\":\"options\",\"del\":\"options\",\"assign\":\"options\",\"update\":\"options\",\"refresh\":\"options\"}"
import script from "./Labels.vue?vue&type=script&lang=js"
export * from "./Labels.vue?vue&type=script&lang=js"
script.render = render

export default script